module.exports = __webpack_public_path__ + "img/entrepreneurship-453.2a768807.png";